import request from '../../utils/request'
import store from '../../store/index'

// 获取报警器列表
export const getAlarmList = (info) => {
  return request({
    url: '/admin-getAlarms',
    method: 'get',
    params: {
      page: store.getters.currentPage,
      page_size: store.getters.pageSize,
      scene: 'system',
      ...info
    }
  })
}
// 获取资源类型
export const getResourceTypes = (info) => {
  return request({
    url: '/admin-getResourceTypes',
    method: 'GET',
    params: {
      scene: 'system',
      ...info
    }
  })
}
// 创建报警器
export const addAlarm = (info) => {
  return request({
    url: '/admin-addAlarm',
    method: 'post',
    data: {
      ...info
    }
  })
}
// 编辑报警器
export const updateAlarm = (info) => {
  return request({
    url: '/admin-updateAlarm',
    method: 'post',
    data: {
      ...info
    }
  })
}
// 批量更新报警器
export const batchUpdateAlarms = (info) => {
  return request({
    url: '/admin-batchUpdateAlarms',
    method: 'post',
    data: {
      alarms: info
    }
  })
}
// 批量删除报警器
export const deleteAlarms = (info) => {
  return request({
    url: '/admin-deleteAlarms',
    method: 'post',
    data: {
      alarm_ids: info
    }
  })
}
// 获取报警器详情
export const getAlarmDetail = (info) => {
  return request({
    url: '/admin-getAlarmDetail',
    method: 'GET',
    params: {
      alarm_id: info
    }
  })
}
// 获取监控主机列表
export const getMonitoringHosts = (info) => {
  return request({
    url: '/admin-getMonitoringHosts',
    method: 'get',
    params: {
      page: store.getters.currentPage,
      page_size: store.getters.pageSize,
      ...info
    }
  })
}
// 获取监控RabbitMQ列表
export const getRabbitMQList = (info) => {
  return request({
    url: '/admin-getMonitoringRabbitMQList',
    method: 'get',
    params: {
      page: store.getters.currentPage,
      page_size: store.getters.pageSize,
      ...info
    }
  })
}
